import { render, staticRenderFns } from "./tan_car_over.vue?vue&type=template&id=ef634eac&scoped=true"
import script from "./tan_car_over.vue?vue&type=script&lang=js"
export * from "./tan_car_over.vue?vue&type=script&lang=js"
import style0 from "./tan_car_over.vue?vue&type=style&index=0&id=ef634eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef634eac",
  null
  
)

export default component.exports